// import React from 'react';
// import Footer from '../Screenss/Footer';
// const Facilities = () => {
//   const primaryColor = "rgb(0, 111, 47)";

//   const facilitiesList = [
//     { title: "Qualified & Experienced Staff", desc: "Our faculty is handpicked — passionate about early childhood education and expert senior staff from across the country.", icon: "👩‍🏫" },
//     { title: "Smart Class in Every Room", desc: "Equipped with Smart Class technology — making learning visual, interactive, and exciting for young minds.", icon: "💻" },
//     { title: "Well-Stacked Library", desc: "A gateway to imagination with physical books and curated digital content to encourage a love for knowledge.", icon: "📚" },
//     { title: "School Transportation", desc: "Safe, reliable, GPS-monitored school buses ensure your child travels comfortably and securely.", icon: "🚌" },
//     { title: "Art & Craft", desc: "Encouraging fine motor development and self-expression through colour, texture, and imagination.", icon: "🎨" },
//     { title: "Pottery Making", desc: "A unique, hands-on experience that teaches patience, focus, and creativity—one of our most beloved programs.", icon: "🏺" },
//     { title: "Music & Dance", desc: "Discovering artistic voices through rhythm and movement, from classical forms to playful music.", icon: "💃" },
//     { title: "Yoga & Aerobics", desc: "Building focus, flexibility, and a healthy foundation for life through daily wellness sessions.", icon: "🧘" },
//     { title: "Indoor & Outdoor Games", desc: "From chess to cricket, our well-equipped play areas ensure every child stays active and joyful.", icon: "⚽" }
//   ];

//   return (
//     <div style={{ paddingTop: "140px", backgroundColor: "#fff", minHeight: "100vh", fontFamily: "Segoe UI, sans-serif" }}>
      
//       {/* 🖼️ HERO BANNER SECTION */}
//       <div style={{
//         width: "100%",
//         height: "350px",
//         position: "relative",
//         backgroundImage: 'url("https://images.unsplash.com/photo-1503676260728-1c00da094a0b?auto=format&fit=crop&w=1350&q=80")', // Aap yahan apni school library ya ground ki image daal sakte hain
//         backgroundSize: "cover",
//         backgroundPosition: "center",
//         display: "flex",
//         alignItems: "center",
//         justifyContent: "center",
//         marginBottom: "50px"
//       }}>
//         {/* Overlay for text readability */}
//         <div style={{
//           position: "absolute",
//           top: 0, left: 0, width: "100%", height: "100%",
//           backgroundColor: "rgba(0, 111, 47, 0.6)" 
//         }}></div>

//         <div style={{ position: "relative", textAlign: "center", color: "#fff", zIndex: 1 }}>
//           <h1 style={{ fontSize: "3.5rem", fontWeight: "800", marginBottom: "10px" }}>Our Facilities</h1>
//           <p style={{ fontSize: "1.4rem", fontStyle: "italic" }}>"A Space Designed for Wonder"</p>
//         </div>
//       </div>

//       <div style={{ maxWidth: "1200px", margin: "0 auto", padding: "0 20px" }}>
        
//         <p style={{ 
//           textAlign: "center", 
//           fontSize: "1.2rem", 
//           color: "#555", 
//           marginBottom: "50px",
//           maxWidth: "800px",
//           margin: "0 auto 50px auto",
//           lineHeight: "1.6"
//         }}>
//           Every corner of DPS Kids Ladwa has been thoughtfully designed to spark curiosity, 
//           encourage exploration, and ensure the safety and happiness of every child.
//         </p>

//         {/* 🏗️ FACILITIES GRID */}
//         <div style={{
//           display: "grid",
//           gridTemplateColumns: "repeat(auto-fit, minmax(350px, 1fr))",
//           gap: "30px",
//           marginBottom: "80px"
//         }}>
//           {facilitiesList.map((item, index) => (
//             <div key={index} style={{
//               padding: "30px",
//               borderRadius: "20px",
//               background: "#fff",
//               boxShadow: "0 10px 25px rgba(0,0,0,0.05)",
//               border: "1px solid #eee",
//               display: "flex",
//               gap: "20px",
//               transition: "transform 0.3s ease",
//               cursor: "default"
//             }}
//             onMouseEnter={(e) => e.currentTarget.style.transform = "translateY(-5px)"}
//             onMouseLeave={(e) => e.currentTarget.style.transform = "translateY(0)"}
//             >
//               <div style={{ 
//                 fontSize: "2.5rem", 
//                 background: "#f0f9f4", 
//                 width: "70px", 
//                 height: "70px", 
//                 display: "flex", 
//                 alignItems: "center", 
//                 justifyContent: "center",
//                 borderRadius: "15px"
//               }}>
//                 {item.icon}
//               </div>
//               <div style={{ flex: 1 }}>
//                 <h3 style={{ color: primaryColor, marginBottom: "10px", fontSize: "1.3rem" }}>{item.title}</h3>
//                 <p style={{ color: "#666", fontSize: "0.95rem", lineHeight: "1.5" }}>{item.desc}</p>
//               </div>
//             </div>
//           ))}
//         </div>

//       </div>

//       {/* 🚩 FINAL QUOTE */}
//       <div style={{ background: "#f9f9f9", padding: "60px 20px", textAlign: "center" }}>
//         <h2 style={{ color: primaryColor, marginBottom: "20px" }}>Safe. Joyful. Smart.</h2>
//         <p>Providing the best-in-class infrastructure for your child's growth.</p>
//       </div>

// <Footer/>
//     </div>
//   );
// };

// export default Facilities;

//   import React, { useContext, useEffect, useState } from "react";
// import { DataContext } from "../Screenss/DataContext";

// const Facilities = () => {
//   const primaryColor = "rgb(0, 111, 47)";
// const { data } = useContext(DataContext);
//  const [current, setCurrent] = useState(0);
// const galleryItems = data.filter(
//     (item) => item.category === "ourschool"
//   );

//   // 🔁 Auto Slide
//   useEffect(() => {
//     if (galleryItems.length === 0) return;

//     const interval = setInterval(() => {
//       setCurrent((prev) =>
//         prev === galleryItems.length - 1 ? 0 : prev + 1
//       );
//     }, 3000); // 3 sec

//     return () => clearInterval(interval);
//   }, [galleryItems]);
//   const facilitiesList = [
//     { title: "Qualified & Experienced Staff", desc: "Our faculty is handpicked — passionate about early childhood education and expert senior staff from across the country.", icon: "👩‍🏫" },
//     { title: "Smart Class in Every Room", desc: "Equipped with Smart Class technology — making learning visual, interactive, and exciting for young minds.", icon: "💻" },
//     { title: "Well-Stacked Library", desc: "A gateway to imagination with physical books and curated digital content to encourage a love for knowledge.", icon: "📚" },
//     { title: "School Transportation", desc: "Safe, reliable, GPS-monitored school buses ensure your child travels comfortably and securely.", icon: "🚌" },
//     { title: "Art & Craft", desc: "Encouraging fine motor development and self-expression through colour, texture, and imagination.", icon: "🎨" },
//     { title: "Pottery Making", desc: "A unique, hands-on experience that teaches patience, focus, and creativity—one of our most beloved programs.", icon: "🏺" },
//     { title: "Music & Dance", desc: "Discovering artistic voices through rhythm and movement, from classical forms to playful music.", icon: "💃" },
//     { title: "Yoga & Aerobics", desc: "Building focus, flexibility, and a healthy foundation for life through daily wellness sessions.", icon: "🧘" },
//     { title: "Indoor & Outdoor Games", desc: "From chess to cricket, our well-equipped play areas ensure every child stays active and joyful.", icon: "⚽" }
//   ];

//   return (
//     <div style={{
//       paddingTop: "clamp(100px, 10vw, 140px)",
//       backgroundColor: "#fff",
//       minHeight: "100vh",
//       fontFamily: "Segoe UI, sans-serif"
//     }}>
//   <section style={styles.hero}>
//         <div style={styles.heroImageWrap}>
          
//           {galleryItems.length > 0 && (
//             <img
//               src={galleryItems[current].full_url}
//               alt="school banner"
//               style={styles.heroImage}
//             />
//           )}

//           <div style={styles.heroOverlay} />

//           {/* <div style={styles.heroContent}>
//             <h1 style={styles.heroTitle}>
//               Building Foundations That Last a Lifetime
//             </h1>
//             <p style={styles.heroText}>
//               A school is more than walls and textbooks — it is where futures are shaped, values are rooted, and dreams take flight.
//             </p>
//           </div> */}

//           {/* ✅ Dots Indicator */}
//           <div style={styles.dots}>
//             {galleryItems.map((_, i) => (
//               <span
//                 key={i}
//                 onClick={() => setCurrent(i)}
//                 style={{
//                   ...styles.dot,
//                   backgroundColor:
//                     current === i ? "rgb(0,111,47)" : "#fff",
//                 }}
//               />
//             ))}
//           </div>

//         </div>
//       </section>

//       {/* CONTENT */}
//       <div style={{
//         maxWidth: "1100px", // 🔥 important (tight layout)
//         margin: "0 auto",
//         padding: "0 20px"
//       }}>

//         <p style={{
//           textAlign: "center",
//           fontSize: "clamp(14px, 1.2vw, 18px)",
//           color: "#555",
//           marginBottom: "40px",
//           maxWidth: "700px",
//           marginInline: "auto",
//           lineHeight: "1.6"
//         }}>
//           Every corner of DPS Kids Ladwa has been thoughtfully designed to spark curiosity,
//           encourage exploration, and ensure the safety and happiness of every child.
//         </p>

//         {/* GRID */}
//         <div style={{
//           display: "grid",
//           gridTemplateColumns: "repeat(auto-fit, minmax(280px, 1fr))", // 🔥 FIXED
//           gap: "25px",
//           marginBottom: "60px"
//         }}>

//           {facilitiesList.map((item, index) => (
//             <div
//               key={index}
//               style={{
//                 padding: "22px",
//                 borderRadius: "16px",
//                 background: "#fff",
//                 boxShadow: "0 6px 18px rgba(0,0,0,0.06)",
//                 border: "1px solid #eee",
//                 display: "flex",
//                 gap: "15px",
//                 transition: "all 0.3s ease",
//                 alignItems: "flex-start"
//               }}
//               onMouseEnter={(e) => {
//                 e.currentTarget.style.transform = "translateY(-6px)";
//                 e.currentTarget.style.boxShadow = "0 12px 30px rgba(0,0,0,0.1)";
//               }}
//               onMouseLeave={(e) => {
//                 e.currentTarget.style.transform = "translateY(0)";
//                 e.currentTarget.style.boxShadow = "0 6px 18px rgba(0,0,0,0.06)";
//               }}
//             >

//               <div style={{
//                 fontSize: "26px",
//                 background: "#f0f9f4",
//                 width: "60px",
//                 height: "60px",
//                 display: "flex",
//                 alignItems: "center",
//                 justifyContent: "center",
//                 borderRadius: "12px",
//                 flexShrink: 0
//               }}>
//                 {item.icon}
//               </div>

//               <div>
//                 <h3 style={{
//                   color: primaryColor,
//                   marginBottom: "6px",
//                   fontSize: "16px",
//                   fontWeight: "700"
//                 }}>
//                   {item.title}
//                 </h3>

//                 <p style={{
//                   color: "#666",
//                   fontSize: "14px",
//                   lineHeight: "1.5",
//                   margin: 0
//                 }}>
//                   {item.desc}
//                 </p>
//               </div>

//             </div>
//           ))}

//         </div>
//       </div>

//       {/* FOOT */}
//       <div style={{
//         background: "#f9f9f9",
//         padding: "50px 20px",
//         textAlign: "center"
//       }}>
//         <h2 style={{ color: primaryColor, marginBottom: "10px" }}>
//           Safe. Joyful. Smart.
//         </h2>
//         <p style={{ fontSize: "14px" }}>
//           Providing the best-in-class infrastructure for your child's growth.
//         </p>
//       </div>

      
//     </div>
//   );
// };

// export default Facilities;


import React, { useContext, useEffect, useState } from "react";
import { DataContext } from "../Screenss/DataContext";

const Facilities = () => {
  const primaryColor = "rgb(0, 111, 47)";
  const { data } = useContext(DataContext);
console.log('here is data',data)
  const [current, setCurrent] = useState(0);

  // 🔥 SAFE (no crash)
  const galleryItems = (data || []).filter(
    (item) => item.category === "Facilities"
  );

  // 🔁 Auto Slider
  useEffect(() => {
    if (galleryItems.length === 0) return;

    const interval = setInterval(() => {
      setCurrent((prev) =>
        prev === galleryItems.length - 1 ? 0 : prev + 1
      );
    }, 3000);

    return () => clearInterval(interval);
  }, [galleryItems]);

  const facilitiesList = [
    { title: "Qualified & Experienced Staff", desc: "Our faculty is handpicked and highly experienced.", icon: "👩‍🏫" },
    { title: "Smart Class", desc: "Interactive learning with smart boards.", icon: "💻" },
    { title: "Library", desc: "Well-stocked with books and digital content.", icon: "📚" },
    { title: "Transport", desc: "Safe GPS-enabled buses.", icon: "🚌" },
    { title: "Art & Craft", desc: "Creative activities for kids.", icon: "🎨" },
    { title: "Music & Dance", desc: "Fun with rhythm and movement.", icon: "💃" },
  ];

  return (
    <div style={styles.page}>

      {/* HERO */}
      <section style={styles.hero}>
        <div style={styles.heroWrap}>

          {galleryItems.length > 0 && (
            <img
              src={galleryItems[current]?.full_url}
              alt="banner"
              style={styles.heroImage}
            />
          )}

          <div style={styles.overlay} />

          {/* Dots */}
          <div style={styles.dots}>
            {galleryItems.map((_, i) => (
              <span
                key={i}
                onClick={() => setCurrent(i)}
                style={{
                  ...styles.dot,
                  background: current === i ? primaryColor : "#fff",
                }}
              />
            ))}
          </div>

        </div>
      </section>

      {/* CONTENT */}
      <div style={styles.container}>
        <h2 style={styles.heading}>Our Facilities</h2>

        <div style={styles.grid}>
          {facilitiesList.map((item, i) => (
            <div
              key={i}
              style={styles.card}
              onMouseEnter={(e) => {
                e.currentTarget.style.transform = "translateY(-5px)";
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.transform = "translateY(0)";
              }}
            >
              <div style={styles.icon}>{item.icon}</div>

              <div>
                <h3 style={{ color: primaryColor }}>{item.title}</h3>
                <p style={styles.text}>{item.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* FOOTER */}
      <div style={styles.footer}>
        <h3 style={{ color: primaryColor }}>Safe • Smart • Happy</h3>
        <p>Best environment for your child</p>
      </div>

    </div>
  );
};

export default Facilities;

//////////////////////////////////////////////////////

const styles = {
  page: {
    background: "#fff",
    minHeight: "100vh",
    fontFamily: "sans-serif",
  },

  hero: {
    width: "100%",
  },

  heroWrap: {
    position: "relative",
    width: "100%",
    height: "550px",
    overflow: "hidden",
  },

  heroImage: {
    width: "100%",
    height: "100%",
    objectFit: "cover",
  },

  overlay: {
    position: "absolute",
    inset: 0,
    background: "rgba(0,0,0,0.3)",
  },

  dots: {
    position: "absolute",
    bottom: "15px",
    left: "50%",
    transform: "translateX(-50%)",
    display: "flex",
    gap: "8px",
  },

  dot: {
    width: "10px",
    height: "10px",
    borderRadius: "50%",
    cursor: "pointer",
  },

  container: {
    maxWidth: "1000px",
    margin: "40px auto",
    padding: "0 20px",
  },

  heading: {
    textAlign: "center",
    marginBottom: "30px",
  },

  grid: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fit, minmax(250px, 1fr))",
    gap: "20px",
  },

  card: {
    background: "#fff",
    padding: "20px",
    borderRadius: "12px",
    boxShadow: "0 5px 15px rgba(0,0,0,0.05)",
    display: "flex",
    gap: "15px",
    transition: "0.3s",
  },

  icon: {
    fontSize: "24px",
  },

  text: {
    fontSize: "14px",
    color: "#555",
  },

  footer: {
    background: "#f5f5f5",
    padding: "40px",
    textAlign: "center",
  },
};